import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-heading" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "title is-2" }, "Sobre mim", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "subtitle is-5" }, "João Vitor, \"Rei da programação\"", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "container has-text-justified" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Sou desenvolvedor a "),
    /*#__PURE__*/_createElementVNode("strong", null, "6 anos"),
    /*#__PURE__*/_createTextVNode(", e durante esses anos vim adquirindo cada vez mais experiência como programador, gosto mais de trabalhar na parte do back end, mas já fiz alguns trabalho com front-end como esse portfólio. Atualmente sou formado em "),
    /*#__PURE__*/_createElementVNode("strong", null, "ciência da computação"),
    /*#__PURE__*/_createTextVNode(" e sou desenvolvedor Back-end na startup RevGás. ")
  ])
], -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}